module.exports = new __parcel__URL__("report-single-level-group-by.00911765.svg").toString();